/* eslint-disable no-nested-ternary */
/* eslint-disable import/prefer-default-export */
import { format } from 'date-fns';
import common from '../_common/common_sales';

const datasetParams = {
  mainFile: 'Sales/Outputs/xl_data/Sales_xl_data_justL3MandN3M.csv',
  runDetailsFile: 'Sales/Outputs/xl_data/Sales_xl_data_justL3MandN3M_runDetails.csv',
  tableName: 'Sales_xl',
  mainDateField: 'Date',
  headersRemaps: {
    VALID_PARK_ST: 'State',
    NumberItemsSold: 'SalesUnits',
    NumberItemsSold_AllParks: 'SalesUnits_AllParks',
    Revenue: 'SalesRevenues',
    Raw_Revenue: 'SalesRevenues_Raw',
    ParkCustomerName: 'Reseller',
  },
  valuesRemaps: {
    Channel: {
      'Internet - Consumer Direct': 'Internet',
    },
    ProductType: {
      'MDT/MPT': 'MDT',
    },
    Flag_HOS: {
      0: '0',
    },
    Flag_Group: {
      0: '0',
    },
    Reseller: {
      'ENTERTAINMENT BENEFITS GRP-EZ CORP': 'EBG',
      'ENTERTAINMENT BENEFITS GRP-EZ INMKT': 'EBG',
      'GROUPON INC': 'GROUPON',
      'InsiderGuide com LC': 'InsiderGuide',
    },
  },
  calculatedMetrics: common.sales_calculatedMetrics,
  metrics: common.sales_metrics,
  transformRow: (row) => ({
    ...row,
    Date: format(new Date(row.Date), 'yyyy-MM-dd'),
    Year: format(new Date(row.Date), 'yyyy'),
    YearMonth: format(new Date(row.Date), 'yyyy-MM'),
    ProductCategory: ['SDT', 'MDT'].includes(row.ProductType) ? 'Discrete' : ['FC', 'Fun Card', 'Pass'].includes(row.ProductType) ? 'Pass' : 'Free',
    // ItemName: row.ItemName.replace(/(?<=\b)\d{4}(?=\b)/g, '[Year]'), // too much processing on the client side
  }),
  filterDimensions: {
    ...common.sales_filterDimensions,
    Channel: {
      order: 'desc',
      customOrder: ['Internet', 'In-Park', 'Contact Center', 'Business Partner'],
    },
    BP_Category: {
      order: 'asc',
      customOrder: ['Domestic OTA', 'Domestic In-Market', 'Domestic Military', 'International', 'Groups', 'Others'],
    },
    State: {
      order: 'asc',
      customOrder: ['FL', 'CA', 'TX', 'VA', 'PA'],
    },
    PaymentType: {
      order: 'asc',
    },
    Flag_HOS: {
      order: 'asc',
    },
    Flag_Group: {
      order: 'asc',
    },
    ParkList: {
      order: 'asc',
    },
    ProductCode: {
      order: 'asc',
    },
    ProductName: {
      order: 'asc',
    },
    ItemCode: {
      order: 'asc',
    },
    ItemName: {
      order: 'asc',
    },
    PLU_ID: {
      order: 'asc',
    },
    PLU_Name: {
      order: 'asc',
    },
    // ParkCustomerGroup: {
    //   order: 'asc',
    // },
    // ParkCustomerSubGroup: {
    //   order: 'asc',
    // },
    Reseller: {
      order: 'asc',
      customOrder: [
        'EBG',
        'GROUPON',
        'InsiderGuide',
        'TRIPSTER',
        'PerkSpot',
        'FUN EXPRESS',
        'TRAVELSCAPE/EXPEDIA',
        'ADVANCED RESERVATION SYSTEMS INC',
        'GETAWAY TODAY VACATIONS INC.',
        'VIATOR INC.',
        'UNIVERSAL STUDIOS VACATIONS-DU/UPRV',
        'ALL GUEST SERVICES',
        'CFI HOSPITALITY / WESTGATE RESORTS',
        'Travel + Leisure Co.',
        'Hospitality Connect Florida',
        'Kissimmee Guest Services Inc',
        'HOLIDAY INN CLUB VACATIONS INC',
        'COLONIAL WILLIAMSBURG',
        'DIAMOND RESORTS INTERNATIONAL',
        'WYNDHAM VACATION RESORTS',
        'MILITARY-COMMANDER NAVAL REGION',
        'AIR FORCE CENTRAL TICKETS NAFI-EZ TICKETS',
        'MILITARY - SHADES OF GREEN ',
      ],
    },
  },
};

export default datasetParams;
